module.exports = __webpack_public_path__ + "static/homebg-93a5307587fff920aedb11bbe5300d10.jpg";